import React from "react";
import styles from "./Announcement.module.css";

const Announcement = () => {
    const items = [
        "6 Meses al 30%",
        "-",
        "Pack con Cámara",
        "-",
        "Instalación Rápida",
        "-",
        "Últimos Días",
        "-",
    ];

    return (
        <section className={styles.announcement} aria-label="Beneficios destacados">
            <div className={styles.container}>
                <p>Beneficios:</p>
                <div className={styles.marquee} aria-hidden="true">
                    <div className={styles.marqueeTrack}>
                        {[...items, ...items].map((item, index) => (
                            <span className={styles.marqueeItem} key={`${item}-${index}`}>
                                {item}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Announcement;
